import { formatFloatWithCommasAndDecimals } from 'utils/locales';

export const LISTING_STATUSES = Object.freeze({
  ACTIVE: 'Active',
  SOLD: 'Sold',
  PENDING: 'Pending',
  NOTSOLD: 'NotSold',
  NEW: 'New',
  READONLY: 'ReadOnly'
});

export const MEDIALINK_TYPES = {
  LargeImage: 'LargeImage',
  Image: 'Image',
  Video: 'Video'
};

export const ESTIMATION_MESSAGE =
  'The Seller Suggested Retail Price (SSRP) is the retail price provided by the seller. There is no assurance that the lot will sell or can be resold at such price to anyone. Dealer to dealer market prices and reserve prices are significantly lower than the SSRP. Rapaport warns that SSRP prices are high and does not guarantee the value of any item. Winning Bids may be substantially below the SSRP. Rapaport does not guarantee the value, resale value, or liquidity of any item.';

export const BID_MESSAGES = {
  BELOW_LOWEST_BID: 'Your bid cannot be placed as it has not met the minimum bid price.',
  ABOVE_LOWEST_BID: 'Your Bid cannot be accepted because it is too far above the reserve price',
  BELOW_HEIGHEST_BID: 'Your bid must be above the current highest bid. Please bid again.',
  BELOW_STARTING_PRICE: 'Your bid must be above or equal to the starting price. Please bid again.',
  BELOW_INCREMENT:
    'Your bid must be equal to or higher than the next minimal bid. Please bid again.',
  THE_SAME_AS_CURRENT_BID: 'Your bid cannot be placed as it is the same as the current high bid.',
  ABOVE_CURRENT_HIGHT_BID_AND_BELOW_INCREMENT: val =>
    `Your bid must be ${formatFloatWithCommasAndDecimals(
      val,
      0,
      false,
      '$'
    )} or higher. Please bid again.`
};

export const BID_MESSAGES_CATALOG = {
  BELOW_LOWEST_BID: 'Your offer cannot be placed as it has not met the minimum offer price.',
  ABOVE_LOWEST_BID: 'Your offer cannot be accepted because it is too far above the reserve price',
  BELOW_HEIGHEST_BID:
    'Your offer must be above the current highest offer. Please make a new offer.',
  BELOW_STARTING_PRICE:
    'Your offer must be equal to or above the starting price. Please try again.',
  BELOW_INCREMENT: 'Your offer must be equal to or above the next minimal offer. Please try again.',
  THE_SAME_AS_CURRENT_BID:
    'Your offer cannot be placed as it is the same as the current high offer.',
  ABOVE_CURRENT_HIGHT_BID_AND_BELOW_INCREMENT: val =>
    `Your offer must be above or equal to ${formatFloatWithCommasAndDecimals(
      val,
      0,
      false,
      '$'
    )}. Please place another offer.`
};

export const defaultSortBy = [
  { sortType: 'listingStatus', sortOrderDesc: false },
  { sortType: 'catalogNumber' }
];

export const defaultCatalogSortBy = [{ sortType: 'orderBy' }];
export const defaultCatalogUserSortBy = [
  { sortType: 'listingStatus' },
  { sortType: 'estimateLow' },
  { sortType: 'catalogNumber' }
];
export const defaultClosedSortBy = [
  { sortType: 'listingStatus', sortOrderDesc: false },
  { sortType: 'catalogNumber' }
];

export const listingStatuses = {
  InActiveBuyer: {
    name: 'InActiveBuyer',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Preview',
    bidTextCatalog: 'Preview',
    bidTextCatalogMyLot: 'Preview'
  },
  ActiveBuyerNewBid: {
    name: 'ActiveBuyerNewBid',
    bidAllow: true,
    messageStatus: false,
    messageStatusCatalog: false,
    signupStates: true,
    bidExists: false,
    bidText: 'BID NOW',
    bidTextCatalog: 'Make an offer',
    bidTextCatalogMyLot: 'Make an offer'
  },
  ActiveBuyerUpdateBid: {
    name: 'ActiveBuyerUpdateBid',
    bidAllow: true,
    messageStatus: false,
    messageStatusCatalog: false,
    signupStates: true,
    bidExists: true,
    bidText: 'UPDATE BID',
    bidTextCatalog: 'Update offer',
    bidTextCatalogMyLot: 'Update offer'
  },
  EndedBuyerPending: {
    name: 'EndedBuyerPending',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: true,
    bidText: 'Pending',
    bidTextCatalog: 'Pending',
    bidTextCatalogMyLot: 'Pending'
  },
  EndedBuyerWon: {
    name: 'EndedBuyerWon',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: true,
    bidText: 'Won!',
    bidTextCatalog: 'Won!',
    bidTextCatalogMyLot: 'Won!'
  },
  EndedBuyerLost: {
    name: 'EndedBuyerLost',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: true,
    bidText: 'Did Not Win',
    bidTextCatalog: 'Did Not Win',
    bidTextCatalogMyLot: 'Did Not Win'
  },
  InActiveSeller: {
    name: 'InActiveSeller',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Preview',
    bidTextCatalog: 'Preview',
    bidTextCatalogMyLot: 'Preview'
  },
  ActiveSellerViewBid: {
    name: 'ActiveSellerViewBid',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: false,
    signupStates: false,
    bidExists: false,
    bidText: 'Accepting Bids',
    bidTextCatalog: 'Accepting Offers',
    bidTextCatalogMyLot: 'Accepting Offers'
  },
  EndedSellerBoPending: {
    name: 'EndedSellerBoPending',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Pending',
    bidTextCatalog: 'Pending',
    bidTextCatalogMyLot: 'Pending'
  },
  EndedSellerPending: {
    name: 'EndedSellerPending',
    bidAllow: false,
    messageStatus: false,
    messageStatusCatalog: false,
    signupStates: false,
    bidExists: false,
    bidText: 'View Offer',
    bidTextCatalog: 'View Offer',
    bidTextCatalogMyLot: 'View Offer'
  },
  EndedSellerSold: {
    name: 'EndedSellerSold',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Sold',
    bidTextCatalog: 'Sold',
    bidTextCatalogMyLot: 'Sold'
  },
  EndedSellerNotSold: {
    name: 'EndedSellerNotSold',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Not Sold',
    bidTextCatalog: 'Not Sold',
    bidTextCatalogMyLot: 'Not Sold'
  },
  EndedSellerNoBids: {
    name: 'EndedSellerNoBids',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'No Bid',
    bidTextCatalog: 'No Offer',
    bidTextCatalogMyLot: 'No Offer'
  },
  ActiveSellerBidRejected: {
    name: 'ActiveSellerBidRejected',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Bid Rejected',
    bidTextCatalog: 'Offer Rejected',
    bidTextCatalogMyLot: 'Offer Rejected'
  },
  ActiveBuyerBidRejected: {
    name: 'ActiveSellerBidRejected',
    bidAllow: true,
    messageStatus: false,
    messageStatusCatalog: false,
    signupStates: true,
    bidExists: true,
    bidText: 'Update Bid',
    bidTextCatalog: 'Update Offer',
    bidTextCatalogMyLot: 'Update Offer'
  },
  ActiveSellerNoBid: {
    name: 'ActiveSellerNoBid',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'No Bid',
    bidTextCatalog: 'No Offer',
    bidTextCatalogMyLot: 'Accepting Offers'
  },
  EndedSold: {
    name: 'EndedSold',
    bidAllow: false,
    messageStatus: true,
    messageStatusCatalog: true,
    signupStates: false,
    bidExists: false,
    bidText: 'Sold',
    bidTextCatalog: 'Sold',
    bidTextCatalogMyLot: 'Sold'
  }
};
